import { Package, Search, ShoppingCart, ClipboardList } from 'lucide-react'

const contextMap = {
  cart: { icon: ShoppingCart, title: 'Your cart is empty', text: 'Explore the catalog and add retail products to get started.' },
  inquiry: { icon: ClipboardList, title: 'No items requested', text: 'Browse wholesale products and add them to your quote list.' },
  search: { icon: Search, title: 'No results found', text: 'Try a different search term or category filter.' },
  default: { icon: Package, title: 'Nothing here yet', text: 'Check back later or try another view.' }
}

export function EmptyState({ context = 'default', actionLabel, onAction }) {
  const { icon: Icon, title, text } = contextMap[context] || contextMap.default

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="rounded-full bg-brand-shell p-4">
        <Icon className="h-8 w-8 text-brand-slate" />
      </div>
      <h3 className="mt-4 font-display text-xl font-semibold text-brand-ink">{title}</h3>
      <p className="mt-2 max-w-xs text-sm text-brand-slate">{text}</p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="mt-6 rounded-lg bg-brand-navy px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-ocean"
        >
          {actionLabel}
        </button>
      )}
    </div>
  )
}
